export default __webpack_public_path__ + "static/media/jco.d5936e61.jpg";